export default __webpack_public_path__ + "static/media/ArrowDownSelector.cf85f0f6.svg";